export default __webpack_public_path__ + "static/media/theme_musik.80a63e1e.jpg";